<template>
	<div class="u-tags flex-wrap">
		<template v-for="(item, i) in tags">
			<div v-if="i > 0 && $slots.marker" class="marker"><slot name="marker"></slot></div>
			<div class="item">{{item}}</div>
		</template>
	</div>
</template>

<script>
	export default {
		name: 'cTags',
		
		props: {
			value: [String, Array],
			split: {
				type: String,
				default: ','
			}
		},
		
		computed: {
			tags() {
				return typeof this.value == 'object' ? this.value : this.value.split(this.split).filter(item => item) || [];
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.u-tags {
		gap: 5px;

		.item {
			border-radius: 3px;
			padding: 2px 5px;
			white-space: nowrap;
			color: #333;
			background: #F5F5F5;
		}

		.marker {
			padding: 2px 0;
		}
	}
</style>
